(function (angular) {
	'use strict';

	angular.module('loaderModule', [
		'coreModule'
	]);
})(window.angular);